import styles from "./SignatureModal.module.css";
import {
  useSignatureContinueModal,
  type PropertyRelationshipSubmission,
} from "@/features/protest/viewModal/signatureViewmodal";
import { Gifs } from "@/assets/gifs";
import { Modal } from "@/shared/modal";

type SignatureModalProps = {
  isOpen: boolean;
  selectedPropertyType: "RESIDENTIAL" | "COMMERCIAL" | null;
  propertyRelationship?: PropertyRelationshipSubmission;
  onClose: () => void;
  onSubmit?: () => void;
};

export const SignatureModal = (props: SignatureModalProps) => {
  const vm = useSignatureContinueModal(props);

  return (
    <Modal
      isOpen={vm.visible}
      onClose={vm.onClose}
      showCloseButton={false}
      closeOnBackdropClick={false}
      unconstrained
      className={styles.content}
      bodyClassName={styles.continueModalBody}
      ariaLabel="Continue details"
    >
      <button
        type="button"
        className={styles.closeBtn}
        onClick={vm.onClose}
        aria-label="Close continue modal"
      >
        ✕
      </button>

      {vm.isSuccessModalOpen && (
        <div className={styles.kycCard}>
          <div className={styles.successCard}>
            <div className={styles.successTopText}>
              Congratulations on taking the first big step!
            </div>
            <div className={styles.successHeadline}>YOUR PROTEST HAS BEEN FILED</div>
            <img src={Gifs.andyBigFlex2} alt="Andy celebrating" className={styles.successGif} />
            <div className={styles.successMessage}>
              Great job! All forms have been signed. Now, let&apos;s build a stronger protest with
              more supporting evidence.
            </div>
            <button
              type="button"
              className={styles.successContinueBtn}
              onClick={vm.onSuccessContinue}
            >
              Continue
            </button>
            <div className={styles.successRedirectText}>
              Redirecting to file upload in <span>{vm.successRedirectSeconds}</span> seconds...
            </div>
          </div>
        </div>
      )}

      {!vm.isSuccessModalOpen && (
        <div className={styles.signatureBlock}>
          <h3 className={styles.signatureTitle}>Provide Your Signature</h3>
          <div className={styles.signatureSubTitle}>
            Your signature will be applied to all forms.
          </div>

          <div className={styles.signaturePad}>
            <div className={styles.signaturePadText}>
              <canvas
                ref={vm.signatureCanvasRef}
                className={styles.signatureCanvas}
                onMouseDown={vm.startDrawing}
                onMouseMove={vm.draw}
                onMouseUp={vm.stopDrawing}
                onMouseLeave={vm.stopDrawing}
                onTouchStart={vm.startDrawing}
                onTouchMove={vm.draw}
                onTouchEnd={vm.stopDrawing}
              />
            </div>
            <button
              type="button"
              className={styles.clearBtn}
              onClick={vm.clearSignature}
              disabled={!vm.signature}
              aria-disabled={!vm.signature}
            >
              Clear
            </button>
          </div>

          <label className={styles.consentRow} htmlFor="signature-consent-checkbox">
            <input
              id="signature-consent-checkbox"
              type="checkbox"
              className={styles.consentCheckbox}
              checked={vm.signatureConsentAccepted}
              onChange={(event) => vm.setSignatureConsentAccepted(event.target.checked)}
            />
            <span className={styles.signatureDisclaimer}>
              By signing, you agree that your electronic signature is the legal equivalent of your
              manual signature on these documents.
            </span>
          </label>
        </div>
      )}

      {!vm.isSuccessModalOpen && (
        <div className={styles.footer}>
          <button
            type="button"
            className={styles.payBtn}
            onClick={() => void vm.handleSubmit()}
            disabled={
              !vm.signature ||
              !vm.propertyId.trim() ||
              !vm.signatureConsentAccepted ||
              vm.isSubmitting
            }
            aria-disabled={
              !vm.signature ||
              !vm.propertyId.trim() ||
              !vm.signatureConsentAccepted ||
              vm.isSubmitting
            }
          >
            {vm.isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      )}
    </Modal>
  );
};
